import { ExternalLink } from "lucide-react";
import { FC } from "react";
import { FormattedMessage } from "react-intl";
import { Button } from "~/components/ui/button";
import { Card, CardContent, CardHeader } from "~/components/ui/card";
import { formatDateOnly } from "~/utils/date";

interface DuplicateCaseCardProps {
  caseData: {
    id: string;
    name: string;
    dateOfBirth?: string;
    claimNumber: string;
    dateOfLoss?: string;
    author?: { name: string };
    createdAt: string;
  };
  onViewCase: () => void;
}

export const DuplicateCaseCard: FC<DuplicateCaseCardProps> = ({
  caseData,
  onViewCase,
}) => {
  return (
    <Card className="border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors duration-200 bg-white">
      <CardHeader className="pt-4 px-4 pb-0">
        <div className="flex items-start justify-between">
          <h3 className="text-base font-semibold text-gray-900">
            {caseData.name}
          </h3>
          <Button
            variant="ghost"
            size="icon"
            className="h-5 w-5 p-0 hover:bg-transparent"
            onClick={onViewCase}
          >
            <ExternalLink className="h-4 w-4 text-gray-400" />
          </Button>
        </div>
      </CardHeader>
      <CardContent className="px-4 pb-4">
        <div className="space-y-3">
          <div className="flex justify-between text-sm">
            <div className="flex flex-col">
              <span className="text-gray-500 text-xs">
                <FormattedMessage
                  id="caseHeader.dateOfBirth"
                  defaultMessage="Date of Birth:"
                />
              </span>
              <span className="text-gray-900 font-medium">
                {formatDateOnly(caseData.dateOfBirth)}
              </span>
            </div>
            {caseData.dateOfLoss && caseData.dateOfLoss !== "-" && (
              <div className="flex flex-col">
                <span className="text-gray-500 text-xs">
                  <FormattedMessage
                    id="caseHeader.dateOfLoss"
                    defaultMessage="Date of Loss:"
                  />
                </span>
                <span className="text-gray-900 font-medium">
                  {formatDateOnly(caseData.dateOfLoss)}
                </span>
              </div>
            )}
          </div>

          <div className="flex flex-col">
            <span className="text-gray-500 text-xs">
              <FormattedMessage
                id="caseHeader.claimNumber"
                defaultMessage="Claim or Case #:"
              />
            </span>
            <span className="text-gray-900 font-medium text-sm break-all">
              {caseData.claimNumber}
            </span>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
